import { render, staticRenderFns } from "./TraineeSnippet.vue?vue&type=template&id=c0b9d4ec&scoped=true"
import script from "./TraineeSnippet.vue?vue&type=script&lang=js"
export * from "./TraineeSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b9d4ec",
  null
  
)

export default component.exports